import { Position, Toaster } from "@blueprintjs/core";

export const statusToaster = Toaster.create({
    position: Position.BOTTOM_RIGHT,
});

export const announcementToaster = Toaster.create({
    position: Position.TOP,
});
